import { Classes } from '@blueprintjs/core';
import {
  ItemListRendererProps,
  renderFilteredItems,
} from '@blueprintjs/select';
import classNames from 'classnames';
import * as React from 'react';
import {
  FixedSizeListProps,
  FixedSizeList as _FixedSizeList,
} from 'react-window';

import { SelectItem } from 'bones/utils/select/types';

export interface VirtualizedSelectItemListRendererOptions {
  listRef: React.MutableRefObject<_FixedSizeList | null>;
  noResultsMenuItem: JSX.Element;
}

const FixedSizeList: React.FunctionComponent<FixedSizeListProps> =
  _FixedSizeList as any;

export const virtualizedSelectItemListRenderer =
  <
    SubItemType extends SelectItem | null,
    ItemType extends SelectItem<SubItemType>
  >({
    listRef,
    noResultsMenuItem,
  }: VirtualizedSelectItemListRendererOptions) =>
  // eslint-disable-next-line react/display-name
  (itemListProps: ItemListRendererProps<ItemType>) => {
    const filtered = renderFilteredItems(itemListProps, noResultsMenuItem);
    const filteredItems = Array.isArray(filtered) ? filtered : [filtered];
    return (
      <FixedSizeList
        // @ts-ignore
        ref={listRef}
        className={classNames('sd-virtualized-menu', Classes.MENU)}
        height={Math.min(filteredItems.length * 30, 300)}
        itemCount={filteredItems.length}
        itemSize={30}
        overscanCount={15}
        width="100%"
      >
        {(listProps: { index: number; style: React.CSSProperties }) => (
          <div style={listProps.style}>{filteredItems[listProps.index]}</div>
        )}
      </FixedSizeList>
    );
  };
